import React from "react"
import Navbar from "../../../../Common/Components/Navbar"
import Footer from "../../../../Common/Components/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import TsTaskViewComp from "./Component/TsTaskViewComp"


const TsTaskView =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <TsTaskViewComp />
        </div>
        <Footer />
        </>
    )
}

export default TsTaskView